<template>
    <div>
        <!-- Nothing Found Section -->
        <div class="nothing-found" v-if="!isLoad && items.length === 0 && !isErrorPage && !isSearch">
            <svg class="big-icon">
                <use xlink:href="@/assets/img/big-icons-sprite.svg#pen"></use>
            </svg>
            <div class="text-size-l text-color-grey mt16">Здесь пока ничего нет...</div>
            <div v-if="!isScreencasts" class="rules__btn mt16" @click="openAddRuleParent">
                <span class="elem"><span class="i i-plus6"></span>Добавить правило</span>
            </div>
        </div>

        <!-- Rules List -->
        <div class="rules" v-if="!isLoad">
            <div 
                class="rule" 
                v-for="(item, index) in items" 
                :id="'rule'+item.id" 
                :key="'item_'+item.id" 
                :class="{ rulepreloader: item.texLoading, active: rule.id === item.id }" 
                @click.prevent="toggleRule(index, item, $event)"
            >
                <a :href="'/rules/sid'+item.sectionTop+'/sub'+item.section+'/'+'rule'+item.id" class="rule-top" :id="'rule_'+item.id"></a>
                <div class="rule__preloader-wrapper" v-if="item.texLoading">
                    <div class="rule__preloader"></div>
                </div> 
                <div class="wrapper">
                    <div class="rule__text-container">
                        <div class="rule__text" tabindex="0" :class="{'is-search': isSearch || isScreencasts}">
                            <span v-html="item.name"></span>
                        </div>
                    </div>
                </div>
                <div class="rule__search-sections" v-if="item.sections">
                    <a href="" v-for="section in item.sections" :key="section.id" 
                        class="rule__search-section" 
                        @click.stop.prevent="goToRule(`/sid${item.sections[0].id}${+section.depth > 1 ? '/sub' + section.id : ''}/`)">
                        {{ section.name }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: "List",
    components: {
    },
    props: {
        isErrorPage: {
            type: Boolean,
            default: false
        },
        filterType: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            drag: false,
            canToggle: true,
            highlightedId: false,
        };
    },
    computed: {
        ...mapState({
            isLoad: state => state.rules.isLoadItems,
            isSearch: state => state.rules.isSearch,
            rule: state => state.rules.openedRule,
            user: state => state.users.user,
            popups: state => state.popups.items,
        }),
        ...mapGetters('rules', ['getItems']),
        isScreencasts() {
            return this.$route.name === 'screencasts';
        },
        activeTopSection() {
            return this.$route.params.id || (this.topSections[0] ? this.topSections[0].id : false);
        },
        activeSection() {
            return this.$route.params.subid || (this.sections[0] ? this.sections[0].id : null);
        },
        items: {
            get() {
                return this.$store.getters['rules/getItems'];
            },
            set(value) {
                this.$store.commit('rules/setItemsLocal', { items: value });
            }
        },
        curTopSection() {
            return this.topSections.find(section => section.id === this.activeTopSection) || {};
        },
        isRemovedPage() {
            return this.$route.name === 'rules-removed';
        },
    },
    methods: {
        openAddRuleParent() {
            this.$emit('openAddRule');
        },
        openAddRule(item) {
            this.toggleRoll();
            this.$emit('openeditrule');

            if (this.isSearch) {
                this.$store.commit('rules/setIsSearch', false);
                this.$store.commit('rules/setIsSearchPrev', true);
            } else {
                this.$store.commit('rules/setPreviousSection', {
                    topSection: this.activeTopSection, 
                    section: this.activeSection
                });
            }

            if (this.$route.path !== `/sid${item.sectionTop}/sub${item.section}/`) {
                this.$router.push(`/sid${item.sectionTop}/sub${item.section}/`);
            }
            const tmpDiv = document.createElement("div");
            tmpDiv.innerHTML = item.name;
            item.name = tmpDiv.innerText;

            if (!item.isCheckEdit) {
                const timeout = setTimeout(() => {
                    this.$store.commit('rules/setCheckEditLoader', { id: item, value: true });
                }, 500);

                this.$store.commit('rules/setLoadItems', true);
                this.$store.dispatch('rules/checkEditItem', item)
                    .then((result) => {
                        if (result.status) {
                            this.$store.commit('rules/setLoadItems', false);
                            this.$store.commit('popups/open', { name: this.popups.editDisabled.name });
                        } else {
                            if (this.isRemovedPage) {
                                this.$router.push(`/sid${item.sectionTop}/sub${item.section}/`);
                            }

                            this.$store.dispatch('rules/setEditItem', item).then(() => {
                                this.$store.dispatch('popups/open', { name: this.popups.addRule.name });
                            });
                            document.documentElement.scrollTop = 0;
                        }
                        clearTimeout(timeout);
                        this.$store.commit('rules/setCheckEditLoader', { id: item, value: false });
                    })
                    .catch(() => {
                        this.$store.commit('rules/setCheckEditLoader', { id: item, value: false });
                    });
            }
        },
        goToRule(link) {
            this.$store.commit('rules/setIsSearch', false);
            this.$store.commit('popups/hideRuleDetail', false);
            this.$router.push(link);
        },
        toggleRule(index, item, evt) {
            const alt = evt ? evt.altKey : false;
            document.title = item.name.replace(/<[^>]*>/g, '');;

            if (!alt && !this.drag && !this.isScreencasts) {
                this.$store.commit('rules/setScrollTop', document.documentElement.scrollTop);

                if (this.canToggle) {
                    this.$store.dispatch('rules/getRuleText', {
                        item: item, 
                        index: index, 
                        removed: this.isRemovedPage
                    }).then(() => {
                        this.$store.commit('rules/toggleRule', index);
                        this.$store.dispatch('popups/open', { name: this.popups.ruleDetail.name });
                        this.$store.commit('rules/setOpenedRule', index);
                        document.documentElement.scrollTop = 0;

                        if (item.updated) {
                            this.$store.dispatch('rules/deleteMarks', { id: item.id });
                        }
                    });
                }
                this.highlightedId = false;
            } else if (!this.drag) {
                window.location.href = `${process.env.VUE_APP_PATH_FRONT}/rule/?id=${item.id}`;
            }
        },
        fetchData() {
            return new Promise((resolve) => {
                this.$nextTick(() => {
                    if (this.activeSection || this.isRemovedPage) {
                        this.highlightedId = false;
                        const full = this.$route.hash !== "";
                        const id = this.isRemovedPage ? 'removed' : this.activeSection;

                        this.$store.dispatch('rules/getItems', {
                            id: id, 
                            reload: true, 
                            full: full, 
                            ruleType: this.filterRuleType.value, 
                            topSect: this.activeTopSection
                        }).then(() => {
                            resolve();
                        });
                    } else {
                        resolve();
                    }
                });
            });
        },
        toggleRoll() {
            this.$store.commit('rules/toggleRolled');
        },
    },
    watch: {
        isLoad(val) {
            if (this.items[0]) {
                this.toggleRule(0, this.items[0]);
            }
        }
    }
}
</script>
